import './GameReview.css';
import games from './game_reviews.json';

export const GameReview = () => {
	const gradeIcon = (grade: string) => {
		if (grade === '5') return <img alt='Not found!' src='images/fun.jpg' />;
		else return <img alt='Not found!' src='images/shite.jpg' />;
	};
	const gameTable = games.map((g) => {
		return (
			<div className='game-row' key={g.title}>
				<div className='game-title'>{g.title}</div>
				<div className='game-grade'>{gradeIcon(g.grade)}</div>
				<div className='game-video'>
					<a href={g.video}>Watch</a>
				</div>
			</div>
		);
	});

	return (
		<>
			<h2>Game Reviews</h2>
			<div className='game-table'>{gameTable}</div>
		</>
	);
};
